var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickAccept(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 79,
    viewBox: "0 0 84 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6811 72.4271C59.0245 72.4271 75.5161 56.7967 75.5161 37.5157C75.5161 18.2347 59.0245 2.60437 38.6811 2.60437C18.3378 2.60437 1.84619 18.2347 1.84619 37.5157C1.84619 56.7967 18.3378 72.4271 38.6811 72.4271Z",
    fill: "#6CE4BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4953 6.87939C66.4953 6.87939 83.2515 19.0984 80.7783 42.5032C78.5231 63.8775 52.8964 84.5394 25.0822 71.0023C-5.12992 56.2968 6.6423 24.9763 19.1361 14.7166C30.4121 5.45444 51.4607 3.31701 65.6158 16.1416L36.8019 50.5044L23.3759 35.6207L15.3774 42.5032L37.3281 65.3025L67.4425 27.584",
    stroke: "#2C4A43",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickAccept);
export default __webpack_public_path__ + "static/media/pick-accept.cfe0abd0452749c059199997a4d1a5d3.svg";
export { ForwardRef as ReactComponent };